import React, { useEffect, useState } from 'react';
import LinkService from '../system/LinkService';
import useApiCall from '../system/useApiCall';
import StandardTable from '../common/Component/StandardTable';
import { GridColumns, GridRowsProp } from '@mui/x-data-grid';
import BotCommandTO from './BotCommandTO';
import TableUtil from '../system/TableUtil';
import BotCommandDataDialog from './BotCommandDataDialog';

export default function BotCommandPage() {
  const [editRow, setEditRow] = useState<number | null>(null);
  const [openDataDialog, setOpenDataDialog] = useState<boolean>(false);
  const [saveCount, setSaveCount] = useState<number>(0);
  const [commandList, setCommandList] = useState<BotCommandTO[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const apiCall = useApiCall();

  useEffect(() => {
    getCommandAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [saveCount]);

  useEffect(() => {
    if (editRow === null && openDataDialog) {
      setOpenDataDialog(false);
    } else if (editRow !== null && !openDataDialog) {
      setOpenDataDialog(true);
    }
  }, [editRow, openDataDialog]);

  const getCommandAll = () => {
    setIsLoading(true);
    apiCall.get(LinkService.getBotCommandAll()).then((data) => {
      if (data) {
        const list: BotCommandTO[] = data;
        setCommandList(list);
        setIsLoading(false);
      }
    });
  };

  const deleteBotCommandData = (id: number) => {
    apiCall.delete(LinkService.botCommandDelete(id), 'Datensatz gelöscht.').then((data) => {
      getCommandAll();
    });
  };

  const getEditData = () => {
    const command = commandList.find((item: BotCommandTO) => item.id === editRow);
    return command;
  };

  const columns: GridColumns = [
    { field: 'id', headerName: "ID", width: 30, editable: false, type: 'number'},
    { field: 'name', headerName: 'Befehl', flex: 2, editable: false },
    { field: 'description', headerName: 'Beschreibung', flex: 4, editable: true },
    { field: 'usage', headerName: 'Hilfe', flex: 9, editable: true },
    { field: 'enabled', headerName: 'aktiv', type: 'boolean', flex: 1, editable: true },
    { field: 'lastExecuted', headerName: 'letzte Ausführung', flex: 2, editable: false, valueFormatter: TableUtil.formatDateCell },
    { field: 'cooldownSeconds', headerName: 'Cooldown in Sek.', flex: 2, editable: true, type: 'number'},
  ];

  const rows: GridRowsProp = [...commandList];

  return (
    <div>
      <BotCommandDataDialog
        openDialog={openDataDialog}
        setEditRow={setEditRow}
        editData={editRow ? getEditData() : undefined}
        saveCount={saveCount}
        setSaveCount={setSaveCount}
      />
      <StandardTable
        saveURL={LinkService.botCommandPost()}
        editRowNumber={setEditRow}
        columns={columns}
        rows={rows}
        deleteFunction={deleteBotCommandData}
        isLoading={isLoading}
      />
    </div>
  );
}
